export const htmlId: string = 'building-sites-list';
